import { render, staticRenderFns } from "./ChangeNickname.vue?vue&type=template&id=44754c1e&scoped=true"
import script from "./ChangeNickname.vue?vue&type=script&lang=js"
export * from "./ChangeNickname.vue?vue&type=script&lang=js"
import style0 from "./ChangeNickname.vue?vue&type=style&index=0&id=44754c1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44754c1e",
  null
  
)

export default component.exports